import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-044dff96"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "pt-[8px] px-[8px] bg-System/app_white" }
const _hoisted_3 = { class: "flex items-center justify-center" }
const _hoisted_4 = { class: "overflow-auto max-h-[212px] incredi-scroll-bar-narrow" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" No matches found ")
const _hoisted_6 = ["data-testid"]
const _hoisted_7 = { class: "w-full p-2 build-group-modal-btn" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Manage Build Groups ")

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediList, IncrediItem, IncrediField, IncrediButton } from 'incredi-ui';
import { ref, inject, computed } from 'vue';
import { SelectedAgent } from '@/components/agents-table/AgentActionMenu.types';
import elementsIds from '@/const/elementIds.json';
import { BuildGroupsQuery, useBuildGroupsQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { SYSTEM_BUILD_GROUPS } from '@/views/agents/agents.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'agents-build-group',
  props: {
    agents: null
  },
  emits: ["change", "openDialog"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change', value: { buildGroup: string; status: boolean }): void;
  (e: 'openDialog', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  agents: SelectedAgent[];
}


// eslint-disable-next-line no-unused-vars


const hasInitiator = props.agents.some(agent => agent.metadata?.isInitiator);

const isSearchFocused = ref(false);
const input = ref('');
const openBGDialog = () => {
  emit('openDialog', true);
};
const coordinatorsService = inject(IKCoordinatorsService);
const GQL_useBuildGroup = useBuildGroupsQuery(
  () => ({
    filter: {
      coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
    },
  }),
  { fetchPolicy: 'network-only' },
);
const buildGroups = computed(() => {
  const filteredGroups =
    GQL_useBuildGroup.result.value?.buildGroups?.filter(buildGroup => {
      const searchQueryLower = input?.value?.toLowerCase() || '';
      return buildGroup?.name?.toLowerCase().includes(searchQueryLower);
    }) || [];
  return {
    systemBuildGroups: filteredGroups
      .filter(buildGroup => (hasInitiator && buildGroup?.id === SYSTEM_BUILD_GROUPS.Universal ? false : (Object.values(SYSTEM_BUILD_GROUPS) as (string | null | undefined)[]).includes(buildGroup?.id)))
      .sort(buildGroup => (buildGroup?.id === SYSTEM_BUILD_GROUPS.Universal ? -1 : 1)) as BuildGroupsQuery['buildGroups'],
    buildGroupsList: filteredGroups.filter(buildGroup => !(Object.values(SYSTEM_BUILD_GROUPS) as (string | null | undefined)[]).includes(buildGroup?.id)) as BuildGroupsQuery['buildGroups'],
  };
});

const noResults = computed(() => buildGroups?.value?.systemBuildGroups?.length === 0 && buildGroups?.value?.buildGroupsList?.length === 0);

const getFilteredBuildGroupByKey = (key: string) => {
  if (key === 'systemBuildGroups') {
    return buildGroups.value.systemBuildGroups;
  }
  if (key === 'buildGroupsList') {
    return buildGroups.value.buildGroupsList;
  }
  return [];
};

return (_ctx: any,_cache: any) => {
  const _directive_incredi_focus_trap = _resolveDirective("incredi-focus-trap")!

  return _withDirectives((_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "max-h-[312px] relative",
        "data-testid": _unref(elementsIds).agents.contextMenu.buildGroup.dialog
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(IncrediField), {
            modelValue: input.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event)),
            name: "build-group",
            label: "Search",
            size: "tiny",
            class: "max-w-[184px]",
            clearable: "",
            "data-testid": _unref(elementsIds).agents.contextMenu.buildGroup.input,
            onFocusWithin: _cache[1] || (_cache[1] = ($event: any) => (isSearchFocused.value = true)),
            onBlurWithin: _cache[2] || (_cache[2] = ($event: any) => (isSearchFocused.value = false))
          }, {
            prepend: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("i", {
                  class: _normalizeClass(["uil uil-search text-[24px] mr-2", [isSearchFocused.value ? 'text-System/app_primary' : 'text-System/app_grey_76']])
                }, null, 2)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "data-testid"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(IncrediList), { class: "!shadow-none" }, {
            default: _withCtx(() => [
              (_unref(noResults))
                ? (_openBlock(), _createBlock(_unref(IncrediItem), {
                    key: 0,
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(Object.keys(_unref(buildGroups)), (key, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass([key === 'systemBuildGroups' && _unref(buildGroups).systemBuildGroups?.length && _unref(buildGroups).buildGroupsList?.length ? 'border-b' : ''])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFilteredBuildGroupByKey(key), (buildGroup, buildIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: buildIndex,
                          "data-testid": _unref(elementsIds).agents.contextMenu.buildGroup.list
                        }, [
                          buildGroup
                            ? (_openBlock(), _createBlock(_unref(IncrediItem), {
                                key: 0,
                                selected: __props.agents.every(agent => buildGroup?.name === agent.buildGroup),
                                onClick: ($event: any) => (emit('change', { buildGroup: buildGroup?.id || '', status: true }))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(buildGroup?.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["selected", "onClick"]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_6))
                      }), 128))
                    ], 2))
                  }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(IncrediButton), {
            design: "primary-green",
            size: "tiny",
            class: "w-full flex items-center justify-center",
            onClick: openBGDialog
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ], 8, _hoisted_1)
    ]),
    _: 1
  })), [
    [_directive_incredi_focus_trap, 'agent-add-build-group']
  ])
}
}

})